import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { useAuth } from "@/contexts/AuthContext";
import { http } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const nav = useNavigate();
  const [search] = useSearchParams();
  const ref = search.get("ref");
  const { refresh } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ref) {
      http.post("/referrals/track", { referral_code: ref }).catch(() => {});
    }
  }, [ref]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post(`/auth/register${ref ? `?ref=${encodeURIComponent(ref)}` : ""}`, { email, password, name });
      localStorage.setItem("stc_token", data.token);
      await refresh();
      toast.success("Welcome to the Club.");
      nav("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign-up failed");
    } finally { setLoading(false); }
  };

  return (
    <Layout>
      <section className="bg-[#050505] min-h-[80vh] py-24">
        <div className="max-w-[520px] mx-auto px-6 lg:px-10">
          <div className="font-ui text-[11px] tracking-[0.32em] text-[#C9A055] mb-3">Create Account</div>
          <h1 className="font-display text-5xl text-[#F4F1EA] mb-2">JOIN THE CLUB.</h1>
          <p className="font-script text-[#C9A055] text-2xl mb-8">Save your truths. Track your orders.</p>

          {ref && (
            <div data-testid="ref-banner" className="border border-[#C9A055]/40 bg-[#C9A055]/10 p-3 mb-6">
              <div className="font-ui text-[10px] tracking-[0.32em] text-[#C9A055]">Referral Code Applied</div>
              <div className="font-mono text-[#F4F1EA] text-sm mt-1">{ref}</div>
            </div>
          )}

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <input data-testid="reg-name" required placeholder="Full Name" value={name} onChange={e=>setName(e.target.value)} className="stc-input"/>
            <input data-testid="reg-email" required type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="stc-input"/>
            <input data-testid="reg-password" required type="password" minLength={6} placeholder="Password (min 6 chars)" value={password} onChange={e=>setPassword(e.target.value)} className="stc-input"/>
            <button data-testid="reg-submit" disabled={loading} className="btn-gold w-full">{loading ? "Creating…" : "Create Account"}</button>
          </form>
          <div className="mt-6 font-ui-tight text-sm text-[#B5B0A7]">
            Already a member? <Link to="/login" className="text-[#C9A055] hover:text-[#E0BC72]">Sign in</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
